import { z } from 'zod';
import { vehicleGroupsSchema } from './vehicle-group.schema';

export const vehicleGroupPagedCollectionSchema = z.object({
  size: z.number().min(0),
  data: vehicleGroupsSchema,
});

export type VehicleGroupPagedCollection = z.infer<
  typeof vehicleGroupPagedCollectionSchema
>;
